import type { Router, LocationQueryRaw } from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import { h } from 'vue';
import { useUserStore } from '@/store';
import { isLogin, getToken, setToken } from '@/utils/auth';
import { ElMessageBox } from 'element-plus';
import {getUserProfilesUserInfo} from '@/api/user'

const whiteList = ['/404', '/login']; // no redirect whitelist
const pwdTips = ['/login', '/restsPwd/index', '/', '']
let timeId: any = null
const ruleList = ['/agent/index', '/finance/agent-recharge-record', '/finance/agent-refund-record']

export default function setupUserLoginInfoGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    if (to.query.token) {
      setToken(to.query.token as string)
      window.location.href = `${window.location.origin}/login`
      return
    }
    
    const isPwdSafe = useUserStore().token.is_pwd_safe
    
    NProgress.start();

    if (getToken()) {
      if (to.path === '/login') {
        const userStore = useUserStore();
        next({ path: userStore.defaultRoute || '/notFound' });
      } else {
        next();
      }
      if (timeId) {
        clearTimeout(timeId)
      }
      timeId = setTimeout(() => {
        if (!isPwdSafe && !pwdTips.includes(to.path)) {
          ElMessageBox.confirm(
            h('div', { class: 'info-modal-content' }, [
              h('span', { style: 'margin-bottom: 10px;' }, '您的密码过于简单，请修改密码！'),
            ]),
            '提示',
            {
              confirmButtonText: '前往修改',
              cancelButtonText: '稍后再说',
              closeOnClickModal: false,
            },
          ).then(() => {
            router.push({ path: '/restsPwd/index' })
          })
        }
      }, 2000);
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next();
        return;
      }
      next({
        name: 'login',
        query: {
          redirect: to.name,
          ...to.query,
        } as LocationQueryRaw,
      });
    }
  });
}
